module.exports = "<growl></growl>\n\n<ion-nav-view></ion-nav-view>"


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 390
// module chunks = 0